import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";

async function getAPIKey() {
  return await httpClient.core.get<string>(`/api-key/product-search`, {
    responseType: "text",
  });
}

export const useGetAPIKey = () => {
  return useQuery({
    queryKey: ["product-search-api-key"],
    queryFn: getAPIKey,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};
